import { createContext, useContext } from 'react';

import { Business } from '../../types/businessDetails.types';

interface IServerRenderContext {
  businessDetails: Business;
}

export const ServerRenderContext = createContext<null | IServerRenderContext>(null);

export const useServerRenderContext = () => {
  const serverData = useContext(ServerRenderContext);

  return serverData;
};
